import { SmallModal } from 'components/Modals/SmallModal';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import React from 'react';
import Label from 'components/form/Label/Label';
import { TextBox } from 'components/form/TextBox';

const Calculated = props => {
  const { onChangeTotalAnnualIncome, income, config } = props;
  return (
    <FlexContainer className={'flex-column gap-16'}>
      <Label type={'H4'}>{config?.AccountMixDTI?.title}</Label>
      <Label type={'Body-1'}>{config?.AccountMixDTI?.subTitle}</Label>
      <TextBox
        id="totalAnnualIncome"
        name="totalAnnualIncome"
        datatestid="totalAnnualincome"
        placeholder="Annual gross income"
        value={income?.totalAnnualIncome?.label}
        error={income?.totalAnnualIncomeError}
        fullWidth
        onChange={e => {
          const value = e.target.value;
          onChangeTotalAnnualIncome(value);
        }}
      />
      <Label type={'caption'}>
        Gross annual income includes everything you earn in a year from
        employment, self-employment, investments, retirement income.
      </Label>
    </FlexContainer>
  );
};

const AccountMixSummaryShowModal = props => {
  const {
    isOpenModal,
    onCancel,
    onOk,
    income,
    onChangeTotalAnnualIncome,
    config,
    loading,
  } = props;

  const cancelButtonProps = {
    type: 'link',
    className: 'bold',
  };

  const okButtonProps = {
    type: 'primary',
    className: 'bold width77px height40px borderRadius4',
  };

  return (
    <FlexContainer>
      <SmallModal
        visible={isOpenModal}
        datatestid={'datatestid'}
        wrapClassName="updateBillingModal"
        onCancel={onCancel}
        width={'600px'}
        okText={loading ? 'Saving...' : 'Submit'}
        cancelText={'Cancel'}
        cancelButtonProps={cancelButtonProps}
        okButtonProps={okButtonProps}
        onOk={onOk}
      >
        <Calculated
          income={income}
          onChangeTotalAnnualIncome={onChangeTotalAnnualIncome}
          config={config}
        />
      </SmallModal>
    </FlexContainer>
  );
};
export default AccountMixSummaryShowModal;
